import { FaWrench, FaStar } from "react-icons/fa";
import TabSelector, { TabOption } from "../TabSelector";
import { StepProps } from "../../types";
import { AdvantagePlusContent, ManualAudienceContent } from ".";
import { useFormContext } from "react-hook-form";
import { AdSetFormData } from "../../forms/adset";
import { DialogContext, useDialogWithOptions } from "src/Common/Dialog";

const AudienceTypeSelector = ({
  onAudienceTypeChange,
  initialType = "advantage",
  loading = {},
  search,
  instagramAccounts,
  pages,
}: {
  onAudienceTypeChange?: (type: "manual" | "advantage") => void;
  instagramAccounts?: Array<{
    id: string;
    username: string;
  }>;
  pages?: Array<{
    id: string;
    name: string;
  }>;
  initialType?: "manual" | "advantage";
  search?: StepProps["search"];
  loading?: Record<string, boolean>;
}) => {
  const { open: openDialog, close: closeDialog } =
    useDialogWithOptions(DialogContext);
  const { watch, setValue } = useFormContext<AdSetFormData>();
  const audienceOptions: TabOption[] = [
    {
      id: "manual",
      label: "Manual Audience",
      icon: <FaWrench size={14} />,
      content: (
        <ManualAudienceContent
          instagramAccounts={instagramAccounts}
          pages={pages}
          search={search}
          loading={loading}
        />
      ),
    },
    {
      id: "advantage",
      label: "Advantage+ audience",
      icon: <FaStar size={14} />,
      content: <AdvantagePlusContent search={search} loading={loading} />,
    },
  ];

  const hasCustomAudiences = watch("custom_audiences")?.length > 0;

  const handleOptionChange = (optionId: string) => {
    if (optionId === "advantage" && hasCustomAudiences) {
      openDialog({
        title: "Custom audiences",
        text: "You have custom audiences. Are you sure you want to switch to Advantage+ audience? This will clear your custom audiences.",
        actions: [
          {
            text: "Use Advantage+ audience",
            buttonProps: {
              bg: "red",
              color: "white",
            },
            onClick: () => {
              setValue("custom_audiences", []);
              onAudienceTypeChange?.(optionId as "manual" | "advantage");
              closeDialog();
            },
          },
          { text: "Keep manual" },
        ],
      });
    }

    return true;
  };

  return (
    <TabSelector
      options={audienceOptions}
      optionId={initialType}
      onOptionChange={handleOptionChange}
    />
  );
};

export { AudienceTypeSelector };
